import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { SnCamerasAPI } from '@lib/api/services';
import { SnAspectRatio } from '@lib/common/enums';
import { GOOGLE_MAP_POPUP_DATA } from '@lib/geo/google/map';
import { t } from '@lib/translation/helpers/translation.helper';

import { ClipViewVideoDialogComponent } from '../clip-view-video-dialog/clip-view-video-dialog.component';

@Component({
  selector: 'sn-ai-detection-popup',
  templateUrl: './ai-detection-popup.component.html',
  styleUrls: ['./ai-detection-popup.component.scss'],
})
export class AiDetectionPopupComponent implements OnInit {
  public aspectRatio = SnAspectRatio.Classic;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(GOOGLE_MAP_POPUP_DATA) public data: any,
    private readonly _camerasAPI: SnCamerasAPI,
    private readonly _dialog: MatDialog,
    private readonly _toastrService: ToastrService,
  ) {}

  public ngOnInit(): void {}

  public setViewClip(): void {
    this._camerasAPI
      .getCamera(this.data.source.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (camera) => {
          this._dialog.open(ClipViewVideoDialogComponent, {
            data: {
              camera,
              item: { timestamp: new Date(this.data.details.createdTimestamp) },
              snapshot: this.data.thumbnailUrl,
            },
          });
        },
        error: () => {
          this._toastrService.error(t('common.cameraClipUnavailable'));
        },
      });
  }
}
